import { n as e } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const a = {
  name: "NcAppContentDetails"
};
var s = function() {
  var n = this, t = n._self._c;
  return t("div", { staticClass: "app-content-details" }, [n._t("default")], 2);
}, l = [], r = /* @__PURE__ */ e(
  a,
  s,
  l,
  !1,
  null,
  null,
  null,
  null
);
const c = r.exports;
export {
  c as default
};
